"use client";

import AudioLinesSvg from "../../assets/animations/audio-lines.animated.svg";
import { SvgAnimation, type SvgAnimationProps } from "../svg-animation/svg-animation";

export function AudioLinesAnimation(props: SvgAnimationProps) {
  return <SvgAnimation {...props} svg={AudioLinesSvg} />;
}
